import { SparkRewardsSummary } from '../../../types'
import { USD_MOCK_TOKEN } from '@/domain/types/Token'
import { assets } from '@/ui/assets'
import { InternalLink } from '@/ui/atoms/link/Link'
import { MenuItem } from '@/ui/atoms/menu-item/MenuItem'

export function TopbarMenuSparkRewardsItem({
  totalUsdAmount,
  closeMenu,
}: SparkRewardsSummary & { closeMenu: () => void }) {
  return (
    <MenuItem className="rounded-none" asChild withSeparator>
      <InternalLink to="/rewards" className="group" onClick={closeMenu}>
        <div className="flex flex-col items-start gap-2">
          <span className="typography-label-3 text-secondary">Spark Rewards</span>
          <div className="flex w-full items-center gap-2">
            <img src={assets.page.sparkRewards} className="size-6" />
            <div>{totalUsdAmount ? USD_MOCK_TOKEN.formatUSD(totalUsdAmount) : 'No Rewards yet'}</div>
          </div>
        </div>
      </InternalLink>
    </MenuItem>
  )
}
